import __request__ from "routing/request";
export function suggestFieldValue(validationRequest, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/search/suggest", validationRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function suggestQueryStrings(limit, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/search/suggest/query_strings", null, { "limit": limit }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
